import React, { Component } from "react";
import { connect } from "react-redux";
import ProductList from "@components/ProductList";
import Loading from "@components/Loading";

import { getProductsBySku } from "@store/catalog/actions";
import { trackProductClick } from "@store/tracker/actions";

class ProductsBlock extends Component {
  constructor(props) {
    super(props);

    this.state = {
      productsData: [],
      isLoading: true,
    };
  }

  loadProductsData = async () => {
    const productSkus = this.props.products
      .split(",")
      .map((productSku) => productSku.trim());

    const products = await this.props.getProductsBySku(productSkus);

    const sortedProducts = [...products].sort((a, b) =>
      productSkus.indexOf(a.sku) > productSkus.indexOf(b.sku) ? 1 : -1
    );

    this.setState({
      isLoading: false,
      productsData: sortedProducts,
    });
  };

  componentDidMount() {
    if (
      this.props.valid &&
      this.props.products &&
      this.props.products.length > 0
    ) {
      this.loadProductsData();
    }
  }

  handleProductClick = (product) => {
    // Track product click
    this.props.trackProductClick(product);
  };

  render() {
    const { productsData, isLoading } = this.state;

    if (!isLoading && productsData && productsData.length > 0) {
      return (
        <>
          <div className="ContentEditorView-ProductsBlock">
            <ProductList
              products={productsData}
              containerClass={`flex flex-wrap Products--${this.props.columns}to2`}
              onProductClick={this.handleProductClick}
              listType="contentEditor"
            />
          </div>
          {/* TODO: Ugly hack, remove when migrating from old CSS */}
          <style>{`
            .ContentEditorView-ProductsBlock .Product-nameHeading {
              text-transform: none;
              font-size: 13px;
              letter-spacing: inherit;
              font-size: 13px;
              line-height: 18px;
              font-weight: 400;
              margin: 5px 0;
            }

            .ContentEditorView-ProductsBlock .Product-name {
              color: #595857;
            }
          `}</style>
        </>
      );
    }

    if (isLoading) {
      return <Loading height={120}>{`Se incarca produsele`}</Loading>;
    }

    // No data
    return null;
  }
}

ProductsBlock.defaultProps = {
  columns: 5,
  products: [],
};

export default connect(null, {
  getProductsBySku,
  trackProductClick,
})(ProductsBlock);
